import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { noItemsBannerTrns } from "src/page-components/not-found/trns";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { Link } from "src/components/Link";
import { PATHNAMES } from "src/constants/routes";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const NotFound: FC = () => {
  const { t } = useTranslation();

  return (
    <MetadataWrapper name="not_found">
      <PageWrapper>
        <div className="bg-cover bg-center bg-no-repeat bg-about-us-banner-mobile md:bg-about-us-banner">
          <div className="container flex flex-col items-center justify-center gap-10 max-w-172 mx-auto pt-40 pb-48 lg:pt-72 lg:pb-96">
            <h1 className="text-center text-purple-base text-20 gl:text-52">
              {t(noItemsBannerTrns.title)}
            </h1>

            <p className="text-purple-base gl:text-xl text-center font-thin max-w-172">
              {t(noItemsBannerTrns.description)}
            </p>

            <Link href={PATHNAMES.HOME}>
              <Button
                className="md:text-xl font-medium px-5 py-3 w-full sm:w-auto"
                variant={ButtonVariants.PRIMARY}
              >
                {t(noItemsBannerTrns.goHomeButton)}
              </Button>
            </Link>
          </div>
        </div>
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default NotFound;
